import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { tripSearch } from '../../store/actions/search';

import { Image, ScrollView, StyleSheet, View } from 'react-native';
import { Color, CommonProperties } from '../../styles';
import BaseText from '../BaseText';
import BottomButton from '../BottomButton';

const OneWayBXAlertModal = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  return (
    <ScrollView>
      <View style={styles.body}>
        <Image style={styles.logo} source={require('../../assets/img/login-logo.png')} />
        <BaseText style={styles.title}>{'One-way BusinessExtra Award Exception'}</BaseText>
        <View style={styles.awardMessageContainer}>
          <BaseText style={styles.listTitle}>
            {'BusinessExtra Awards are intended for round-trip flights, but:'}
          </BaseText>
          <BaseText style={styles.list}>{'- They may be used for one-way flights'}</BaseText>
          <BaseText style={styles.list}>
            {'- If used for one-way flights they cannot be reused in the future<'}
          </BaseText>
        </View>

        <BaseText style={styles.paragraph}>
          {'By selecting "Continue," I acknowledge and understand the award one-way exception'}
        </BaseText>
        <View style={styles.bottomButtonContainer}>
          <BottomButton
            style={styles.bottomButton}
            label={'Continue '}
            onPress={() => {
              setLoading(true);
              dispatch(tripSearch());
            }}
            loading={loading}
          />
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  logo: {
    alignSelf: 'center',
    resizeMode: 'contain',
    width: '90%',
    height: 60,
    maxWidth: 300,
    ...CommonProperties.mb5,
  },
  body: {
    marginBottom: 60,
    alignContent: 'stretch',
    ...CommonProperties.p5,
  },
  title: {
    textAlign: 'center',
    ...CommonProperties.h4,
    ...CommonProperties.py1,
  },
  paragraph: {
    textAlign: 'center',
    ...CommonProperties.h3,
    ...CommonProperties.py2,
  },
  awardMessageContainer: {
    width: '100%',
    textAlign: 'center',
    ...CommonProperties.py3,
  },
  listTitle: {
    color: Color.primary,
    ...CommonProperties.h3,
  },
  list: {
    color: Color.primary,
    ...CommonProperties.h3,
    ...CommonProperties.pt2,
    ...CommonProperties.px3,
  },
  bottomButtonContainer: { flex: 1, justifyContent: 'flex-end', width: '100%' },
  bottomButton: { bottom: 0 },
});

export default OneWayBXAlertModal;
